import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type NotificationState = {
  lastQuotationPolicy: number;
  filterUnderstood: boolean;
  policyMenuUnderstood: boolean;
  profileUnderstood: boolean;
};

export const initialState: NotificationState = {
  lastQuotationPolicy: -1,
  filterUnderstood: false,
  policyMenuUnderstood: false,
  profileUnderstood: false,
};

const notificationSlice = createSlice({
  initialState,
  name: 'notification',
  reducers: {
    updateLastQuotationPolicy: (state, action: PayloadAction<number>): void => {
      state.lastQuotationPolicy = action.payload;
    },
    updateFilterUnderstood: (state, action: PayloadAction<boolean>): void => {
      state.filterUnderstood = action.payload;
    },
    updatePolicyMenuUnderstood: (
      state,
      action: PayloadAction<boolean>,
    ): void => {
      state.policyMenuUnderstood = action.payload;
    },
    updateProfileUnderstood: (state, action: PayloadAction<boolean>): void => {
      state.profileUnderstood = action.payload;
    },
  },
});

export const {
  updatePolicyMenuUnderstood,
  updateFilterUnderstood,
  updateLastQuotationPolicy,
  updateProfileUnderstood,
} = notificationSlice.actions;

export default notificationSlice.reducer;
